import { omit } from 'lodash'
import { NlpModel } from '@feedyou-ai/feedbot-schema'

import { injectModelsToSchema as injectModelsToSchemaForNlpModelTest } from './injectModelsToSchema'

export function injectModelsToSchemaWithoutExpectedModelMatchOption<T>(
  schema: T | any,
  models: NlpModel[]
) {
  const schemaWithInjectedModels = injectModelsToSchemaForNlpModelTest(schema, models)
  return {
    ...schemaWithInjectedModels,
    properties: {
      ...omit(schemaWithInjectedModels.properties, ['testData']),
      testAgainstModels: {
        ...schemaWithInjectedModels.properties.testAgainstModels,
        //@ts-ignore
        oneOf: schemaWithInjectedModels.properties.testAgainstModels.oneOf.filter(item =>
          ['ALL', 'CHOOSE'].includes(item?.properties?.mode?.const)
        )
      }
    }
  }
}
